<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import VideoIframe from "@/components/video/VideoIframe.vue";
import AssistedInstallation from "@/components/onsiteEditor/components/installation/AssistedInstallation.vue";
import InstallationInformation from "@/components/onsiteOptimizer/installation/InstallationInformation.vue";
import DIYInstallation from "@/components/onsiteOptimizer/installation/DIYInstallation.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";

defineProps({
  isOnboarding: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const store = useStore();
const loading = ref(true);

onMounted(async () => {
  await Promise.all([
    store.dispatch('user/getUser'),
    store.dispatch('onsiteEditorInstallation/fetchInstallationOptions'),
    store.dispatch('onsiteEditorInstallation/fetchOptimiserInstallationStatus'),
    store.dispatch('onsiteEditorInstallation/fetchCanUserBypassOptimiserInstallation'),
  ])
    .finally(() => {
      loading.value = false;
    })
});


let currentStep = ref('InstallationInformation');

const videoUrl = computed(() => {
  if (currentStep.value !== 'DIYInstallation') {
    return false;
  }

  return store.getters['onsiteEditorInstallation/installation'].find(
    instructions => instructions.value === store.getters['onsiteEditorInstallation/activeFilter']
  )?.videoUrl ?? false;
});

</script>

<template>
  <LoadingBlock v-if="loading" />
  <div
    v-else
    class="tw-flex tw-flex-col tw-gap-8"
  >
    <VideoIframe
      v-if="videoUrl"
      :video-url="videoUrl"
      class="tw-h-96 tw-w-full"
    />

    <InstallationInformation
      v-if="currentStep === 'InstallationInformation'"
      @next-step="() => currentStep = 'DIYInstallation'"
      @go-to-assisted="() => currentStep = 'AssistedInstallation'"
    />

    <DIYInstallation
      v-if="currentStep === 'DIYInstallation'"
      :is-onboarding="isOnboarding"
      @go-to-assisted="() => currentStep = 'AssistedInstallation'"
      @back="() => currentStep = 'InstallationInformation'"
    />

    <AssistedInstallation
      v-if="currentStep === 'AssistedInstallation'"
      class="!tw-mb-0 !tw-p-0 tw-text-base tw-text-left"
      :using-global-styling="true"
      @back="() => currentStep = 'InstallationInformation'"
    />
  </div>
</template>
